// Filters
const professionalProfilePicture = professional => {
  return professional.account.profile.profile_picture;
};

const professionalFullName = professional => {
  return `${professional.account.first_name} ${professional.account.last_name}`;
};

const professionalTotalOrders = professional => {
  const totalOrders = professional.completed_orders_count;

  return totalOrders < 5 ? "< 5" : totalOrders;
};

const professionalRating = professional => {
  return professional.rating;
};

export default {
  methods: {
    haveAvailableCoupons(coupons) {
      return !coupons ? false : true;
    }
  },
  filters: {
    professionalProfilePicture,
    professionalFullName,
    professionalTotalOrders,
    professionalRating
  }
};



// WEBPACK FOOTER //
// ./src/mixins/professionalMixin.js